// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1Zgrc","vLegacy":"SelectSecondary_vLegacy__1Mf5d","error":"SelectSecondary_error__3cilO","disabled":"SelectSecondary_disabled__3qojO"};